(function ($) {
  $(function () {
    function responsiveBehavior() {
      let sectors$ = $(".scroller-wrapper");
      let scroll$ = 0;
      let delay$ = 350;

      let nav$ = $(".initiative-nav");
      let navTitle$ = nav$.find(".initiative-nav-title");

      if (window.matchMedia("(max-width: 991px)").matches) {
        nav$.find("ul").addClass("initiative-nav-content");

        if (sectors$.length > 0) {
          sectors$.each(function () {
            let sector$ = $(this);

            let next$ = sector$.find(".next");
            let prev$ = sector$.find(".prev");
            let scrollLeft$ = sector$.find(".sector:eq(0)").outerWidth() - 1;

            if (sector$.hasClass("filter-wrapper")) {
              scrollLeft$ =
                sector$.find(".sector:eq(0)").outerWidth() +
                parseInt(sector$.css("gap"));
            }

            next$.on("click", function () {
              sector$.animate(
                {
                  scrollLeft: "+=" + scrollLeft$,
                },
                delay$,
                function () {
                  scroll$ = sector$.scrollLeft();
                }
              );
            });

            prev$.on("click", function () {
              sector$.animate(
                {
                  scrollLeft: "-=" + scrollLeft$,
                  scroll$: "-=" + scrollLeft$,
                },
                delay$,
                function () {
                  scroll$ = sector$.scrollLeft();
                }
              );
            });

            sector$.on("scroll", function () {
              scroll$ = sector$.scrollLeft();
              setTimeout(() => {
                if (scroll$ > 0) {
                  prev$.removeClass("disabled");
                } else {
                  prev$.addClass("disabled");
                }

                if (
                  sector$.find(".sector:last").position().left <=
                  sector$.width() - scrollLeft$
                ) {
                  next$.addClass("disabled");
                } else {
                  next$.removeClass("disabled");
                }

                if (sector$.hasClass("filter-wrapper")) {
                  if (
                    sector$.find(".sector:last").position().left <=
                    sector$.width() - scrollLeft$ + parseInt(sector$.css("gap"))
                  ) {
                    next$.addClass("disabled");
                  } else {
                    next$.removeClass("disabled");
                  }
                }
              }, delay$);
            });
          });
        }

        let styleSheets = document.styleSheets;

        let childrensInactive$ = "1fr ";
        let childrensActive$ = "1fr ";

        let linksContainer$ = nav$.find("ul");

        for (let i = 1; i < linksContainer$.children().length; i++) {
          childrensInactive$ += "0fr ";
          childrensActive$ += "1fr ";
        }

        for (let i = 0; i < styleSheets.length; i++) {
          let sheet = styleSheets[i];
          let rules = sheet.cssRules || sheet.rules;

          for (let j = 0; j < rules.length; j++) {
            let rule = rules[j];

            if (rule.selectorText === ".initiative-nav-content") {
              rule.style.gridTemplateRows = childrensInactive$;
            }
            if (rule.selectorText === ".active .initiative-nav-content") {
              rule.style.gridTemplateRows = childrensActive$;
            }
          }
        }

        navTitle$.on("click", function () {
          nav$.toggleClass("active");
        });
      } else {
        nav$.find("ul").removeClass("initiative-nav-content");
      }
    }

    responsiveBehavior();

    $(window).on("resize", function () {
      responsiveBehavior();
    });
  });
})(jQuery);
